import axios from "axios";
import {useCoreStore} from "@/stores/CoreStore";
import {useDesignerStore} from "@/stores/DesignerStore";
import {useToast} from "vue-toastification";

export default class CoreService {
    constructor(pageData) {
        const coreStore = useCoreStore();
        coreStore.pageData = pageData.pageData;

        this.baseUrl = process.env.VUE_APP_API_URL
        this.id = pageData.productId

        // Create Axios instance with base URL
        this.axios = axios.create({
            baseURL: this.baseUrl,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                'Authorization': 'Bearer ' + coreStore.pageData.apiKey
            },
        });


        // this.getBranding()
        coreStore.page = 'pg-' + pageData.page

    }



    changePage(page, pageData = null, reset = true) {
        const coreStore = useCoreStore();
        const designerStore = useDesignerStore();

        if (reset) {
            designerStore.resetStore();
        }

        if (pageData) {
            coreStore.pageData = pageData;
        }

        coreStore.page = 'pg-' + page;
    }


    // async getBranding() {
    //     const coreStore = useCoreStore();
    //     let requestUrl = window.location.hostname;
    //
    //     let branding = await this.axios.post('/api/branding/lookup', {
    //         domain: requestUrl
    //     })
    //
    //     coreStore.branding = branding.data;
    //     coreStore.coreLoading = false;
    // }

}